import { createRoute, Navigate } from '@tanstack/react-router'
import { projectRoute } from './route'

export const projectIndexRoute = createRoute({
  getParentRoute: () => projectRoute,
  path: '/',
  component: ProjectIndex,
})

function ProjectIndex() {
  const { projectId } = projectIndexRoute.useParams()
  // Keep the search: `/<projectId>?settings=plugins&mcpStatus=…` (the plugin OAuth
  // callback, any settings deep link) must survive the hop to the chat page.
  return <Navigate to="/$projectId/chat" params={{ projectId }} search={true as never} replace />
}
